import React, { useState, useEffect } from 'react';

const CustomerFormModal = ({ show, onClose, onSave, customer }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    mobile: '',
    address: '',
  });

  useEffect(() => {
    if (customer) {
      setForm({ ...customer });
    } else {
      setForm({ name: '', email: '', mobile: '', address: '' });
    }
  }, [customer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Saving customer:', form);
    onSave(form);
  };

  if (!show) return null;

  return (
    <div className="modal" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog" style={{ maxWidth: '600px' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{customer ? 'Edit Customer' : 'Add Customer'}</h5>
            <button type="button" className="close" onClick={onClose}>&times;</button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body" style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
              <div className="form-group">
                <label>Name</label>
                <input type="text" className="form-control" name="name" value={form.name} onChange={handleChange} required autoComplete="off" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} required autoComplete="off" />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input type="text" className="form-control" name="mobile" value={form.mobile} onChange={handleChange} autoComplete="off" />
              </div>
              <div className="form-group">
                <label>Address</label>
                <textarea className="form-control" name="address" value={form.address} onChange={handleChange} autoComplete="off" />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary">{customer ? 'Update' : 'Add'}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CustomerFormModal; 